(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["matarah-quantity-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function start() {
    var root = document.getElementById('matarah-quantity-offer');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var dialog = root.querySelector('.matarah-quantity-offer__dialog');
    var closeButton = root.querySelector('.matarah-quantity-offer__close');
    var eyebrow = root.querySelector('.matarah-quantity-offer__eyebrow');
    var title = root.querySelector('.matarah-quantity-offer__title');
    var message = root.querySelector('.matarah-quantity-offer__message');
    var action = root.querySelector('.matarah-quantity-offer__action');
    var error = root.querySelector('.matarah-quantity-offer__error');
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var timer = null;
    var currentOffer = null;

    var groups = [
      {
        key: 'central',
        ids: [7417889751142, 7417889816678, 7417889849446, 7417889882214, 7417889914982, 7417890013286, 7417890046054, 7417890078822, 7417890111590, 7417890144358, 7417890177126, 7417890209894, 7417890242662, 7417890275430, 7417890373734, 7417890406502]
      },
      {
        key: 'water',
        ids: [7417889488998, 7417889521766, 7417889652838, 7417890340966, 7417890472038]
      }
    ];

    function replaceRemaining(value, remaining) {
      return value.replace('[remaining]', String(remaining));
    }

    function findOffer(cart) {
      var offers = groups.map(function (group) {
        var quantity = 0;
        var variantId = null;

        cart.items.forEach(function (item) {
          if (group.ids.indexOf(Number(item.product_id)) !== -1) {
            quantity += Number(item.quantity);
            if (!variantId) variantId = Number(item.variant_id);
          }
        });

        return {
          key: group.key,
          quantity: quantity,
          remaining: 10 - quantity,
          variantId: variantId
        };
      }).filter(function (offer) {
        return offer.quantity >= 2 && offer.quantity < 10 && offer.variantId;
      });

      offers.sort(function (a, b) {
        return b.quantity - a.quantity;
      });

      return offers[0] || null;
    }

    function showOffer(offer) {
      var signature = offer.key + ':' + offer.quantity;
      if (window.sessionStorage.getItem('matarah-offer-signature') === signature) return;

      currentOffer = offer;
      window.sessionStorage.setItem('matarah-offer-signature', signature);
      eyebrow.textContent = root.dataset.eyebrow;
      title.textContent = offer.key === 'central' ? root.dataset.centralTitle : root.dataset.waterTitle;
      message.textContent = replaceRemaining(
        offer.key === 'central' ? root.dataset.centralMessage : root.dataset.waterMessage,
        offer.remaining
      );
      action.textContent = replaceRemaining(root.dataset.button, offer.remaining);
      action.disabled = false;
      error.hidden = true;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function checkCart() {
      fetch(rootPath + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
        .then(function (cart) {
          var offer = findOffer(cart);
          if (offer) showOffer(offer);
        })
        .catch(function () {});
    }

    function scheduleCheck() {
      window.clearTimeout(timer);
      timer = window.setTimeout(checkCart, 650);
    }

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    action.addEventListener('click', function () {
      if (!currentOffer) return;

      action.disabled = true;
      action.textContent = root.dataset.loading;
      error.hidden = true;

      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: currentOffer.variantId,
            quantity: currentOffer.remaining
          }]
        })
      })
        .then(function (response) {
          if (!response.ok) return Promise.reject();
          return response.json();
        })
        .then(function () {
          dialog.close();
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: currentOffer.remaining }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        })
        .catch(function () {
          action.disabled = false;
          action.textContent = replaceRemaining(root.dataset.button, currentOffer.remaining);
          error.textContent = root.dataset.error;
          error.hidden = false;
        });
    });

    document.addEventListener('product:added', scheduleCheck);
    document.documentElement.addEventListener('product:added', scheduleCheck);
    document.addEventListener('cart:refresh', scheduleCheck);
    document.documentElement.addEventListener('cart:refresh', scheduleCheck);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[name="updates[]"], [data-quantity-input]')) {
        scheduleCheck();
      }
    });

    var previousFetch = window.fetch;
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input.url;
      var result = previousFetch.apply(this, arguments);
      if (requestUrl && /\/cart\/(add|change|update)\.js/.test(requestUrl)) {
        result.then(scheduleCheck).catch(function () {});
      }
      return result;
    };

    window.setTimeout(checkCart, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
